import { forwardRef } from "react";
import Input, { type InputProps } from "./Input";

/** UI bounds for percentage fields in [0, 100] with centi-percent precision. */
const PERCENT_INPUT_MIN = 0;
const PERCENT_INPUT_MAX = 100;
const PERCENT_INPUT_STEP = 0.01;

export type PercentInputProps = Omit<
  InputProps,
  "type" | "min" | "max" | "step"
>;

/**
 * Percentage entry in [0, 100] for fields stored as API rates in [0, 1].
 * Pair with `rateFromPercentInput` / `rateFromUIPercent` on submit and
 * `commissionPercentStringFromRate` when seeding from API values.
 */
const PercentInput = forwardRef<HTMLInputElement, PercentInputProps>(
  (props, ref) => (
    <Input
      ref={ref}
      type="number"
      min={PERCENT_INPUT_MIN}
      max={PERCENT_INPUT_MAX}
      step={PERCENT_INPUT_STEP}
      inputMode="decimal"
      {...props}
    />
  ),
);

PercentInput.displayName = "PercentInput";

export default PercentInput;
